//"Rating Settings", script to edit groups name
(function() {
	document.addEventListener("DOMContentLoaded", function() {
		var titles = document.getElementsByClassName("main-table__th_title");

		if(titles.length != 0) {
			/*for(let i = 0; i < titles.length; i++) {
				titles[i].classList.add("pencil");
				titles[i].setAttribute("title", "double click for edit");

				titles[i].addEventListener("dblclick", function() {
					Editor.addField(this);
				});
			}*/
		};

		//module
		var Editor = {
			addField(el) {
				this.elem = el;
				this.oldName = this.elem.dataset.name;
				this.inputName = this.oldName + "[question]";

				//create field (input type=text) for edit
				this.elem.classList.remove("pencil");
				this.elem.innerHTML = `<input class="editField" name=${this.inputName} type="text">
								<span class="cancel"></span>`;

				this.input = this.elem.getElementsByClassName("editField")[0];
				this.input.value = this.oldName;

				//change
				//if the user entered only spaces
				this.elem.getElementsByClassName("editField")[0].addEventListener("change", function() {
					if( ! /\S/.test(  this.value  ) ) {
						Editor.input.value = Editor.oldName;
					}
				});

				//click on cancel icon
				this.elem.getElementsByClassName("cancel")[0].addEventListener("click", function() {
					Editor.cansel(Editor.oldName);
				});
			},

			cansel(txt) {
				Editor.elem.innerHTML = txt;
				Editor.elem.classList.add("pencil");
			}
		};

	});
})();
